<template>
  <div class="autodesk-callback">
    <b-icon pack="fas" icon="spinner" custom-class="fa-spin" size="is-large" />
  </div>
</template>

<script>
// Página de aterrizaje tras el callback OAuth de Autodesk.
// El backend redirige a /autodesk/callback?success=1 o /autodesk/callback?error=...
// Recuperamos la ruta desde la que se inició el OAuth (guardada en sessionStorage
// por acc-project-browser antes de saltar a Autodesk) y navegamos de vuelta.
// Si no hay retorno guardado, caemos a /select-project como red de seguridad.
const STORAGE_KEY = 'autodesk_oauth_return_to';

export default {
  name: 'autodesk-callback',
  middleware: 'auth',

  mounted() {
    const returnTo = sessionStorage.getItem(STORAGE_KEY) || '/select-project';
    sessionStorage.removeItem(STORAGE_KEY);
    this.$router.replace(returnTo);
  },
};
</script>

<style scoped>
.autodesk-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  color: #5d6b82;
}
</style>
